import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { Products } from './product-configuration.actions';
import { PpmFormlyLayout, ProductDataInstanceInput } from '../../pages/products/product.model';

export interface ProductConfigurationStateModel {
  projectId: string | null;
  productId: string | null;
  instanceInput: ProductDataInstanceInput | null;
  formlyLayout: PpmFormlyLayout | null;
  productState: string | null;
  instanceOutputs: unknown | null;
  selectedOutputKey: number | null;
}

const defaults: ProductConfigurationStateModel = {
  projectId: null,
  productId: null,
  instanceInput: null,
  formlyLayout: null,
  productState: null,
  instanceOutputs: null,
  selectedOutputKey: null,
};

@State<ProductConfigurationStateModel>({
  name: 'productConfiguration',
  defaults,
})
@Injectable()
export class ProductConfigurationState {
  @Selector()
  static instanceInput(state: ProductConfigurationStateModel): ProductDataInstanceInput | null {
    return state.instanceInput;
  }

  @Selector()
  static productState(state: ProductConfigurationStateModel): string | null {
    return state.productState;
  }

  @Selector()
  static instanceOutputs(state: ProductConfigurationStateModel): unknown | null {
    return state.instanceOutputs;
  }

  @Selector()
  static selectedOutputKey(state: ProductConfigurationStateModel): number | null {
    return state.selectedOutputKey;
  }

  @Selector()
  static formlyLayout(state: ProductConfigurationStateModel): PpmFormlyLayout | null {
    return state.formlyLayout;
  }

  @Action(Products.StartConfiguration)
  startConfiguration(ctx: StateContext<ProductConfigurationStateModel>, action: Products.StartConfiguration): void {
    ctx.patchState({
      projectId: action.projectId,
      productId: action.productId,
      instanceInput: action.instanceInput,
      formlyLayout: action.formlyLayout,
      productState: action.productState,
      instanceOutputs: null,
      selectedOutputKey: null,
    });
  }

  @Action(Products.TriggerCalculation)
  triggerCalculation(ctx: StateContext<ProductConfigurationStateModel>): void {
    ctx.patchState({ productState: 'Calculating' });
  }

  @Action(Products.CalculationStatusPolled)
  calculationStatusPolled(ctx: StateContext<ProductConfigurationStateModel>, action: Products.CalculationStatusPolled): void {
    ctx.patchState({
      productState: action.status,
      instanceOutputs: action.instanceOutputs,
    });
  }

  @Action(Products.FieldUpdateReceived)
  fieldUpdateReceived(ctx: StateContext<ProductConfigurationStateModel>, action: Products.FieldUpdateReceived): void {
    const instanceInput = action.ppmResponse.productData?.instanceInput ?? null;
    ctx.patchState({ instanceInput });
  }

  @Action(Products.OutputSelected)
  outputSelected(ctx: StateContext<ProductConfigurationStateModel>, action: Products.OutputSelected): void {
    ctx.patchState({ selectedOutputKey: action.selectedOutputKey });
  }
}
